import { useSelector } from './basic'

const useChatPerms = () => {
  const { gold, chatAllowed } = useSelector(s => s.myProfile)
  return !(gold || chatAllowed)
}

export { useChatPerms as default, useChatPerms }
